module.exports = __webpack_public_path__ + "react/assets/actions/hidden-eye.png";